var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"content-section"},[_c('Heading',{staticClass:"content-section__heading",attrs:{"level":"h3"}},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"content-section__content"},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }